import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./slices/authSlice";
import catalogReducer from "./slices/catalogSlice";
import uiReducer from "./slices/uiSlice";
import walletReducer from "./slices/walletSlice";
import gatewaysReducer from "./slices/gatewaysSlice";
import virtualNumberReducer from "./slices/virtualNumberSlice";

// The wallet slice holds `crypto` (deposit methods) which MUST always be
// fetched fresh from the server — never restored from localStorage, otherwise
// admin changes (new QR, fields, ...) would not appear on the storefront.
// So we persist the wallet slice but blacklist `crypto`.
const walletPersistConfig = {
  key: "wallet",
  storage,
  blacklist: ["crypto"],
};

const rootPersistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "catalog", "wallet", "ui"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  catalog: catalogReducer,
  ui: uiReducer,
  wallet: persistReducer(walletPersistConfig, walletReducer),
  gateways: gatewaysReducer,
  virtualNumbers: virtualNumberReducer,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE", "persist/PURGE"],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
